import { defineAsyncComponent, h } from 'vue';
import { useDrawer } from '@bc/shared/drawer/use-drawer';
import { useBreakpoints } from '@monolith/legacy/modules/design-system-candidates';
import { parseLegacyProductId } from '@bc/shared/util/parse-legacy-product-id';

const ProductPage = defineAsyncComponent(() => import('@client/monolith/legacy/components/brand/product.vue'));

export const useProductQuickView = () => {
  // useDrawer is memoized (singleton): every call returns the same instance, so multiple
  // components calling useProductQuickView share one drawer rather than opening separate ones.
  const { openDrawer, closeDrawer, isOpen } = useDrawer();
  const { isBelowXl, isBelowLg } = useBreakpoints();

  const openProductQuickView = (productId: number, initialVariantId?: number): void => {
    openDrawer(() => h(ProductPage, { productId, onDrawer: true, initialVariantId }), {
      right: true,
      width: isBelowXl.value ? '100%' : '60%',
      bottom: isBelowLg.value ? true : false,
      class: 'product-quick-view-drawer',
    });
  };

  const openProductQuickViewFromPath = (path: string, initialVariantId?: number): boolean => {
    const productId = parseLegacyProductId(path);
    if (productId === null) {
      return false;
    }
    openProductQuickView(productId, initialVariantId);
    return true;
  };

  return {
    openProductQuickView,
    openProductQuickViewFromPath,
    closeProductQuickView: closeDrawer,
    isProductQuickViewOpen: isOpen,
  };
};
